export default "__VITE_ASSET__UjYPFqtF__"